import { Controller } from '@hotwired/stimulus';
import { toInteger } from 'lodash';
import Overlay from '../../../libs/cifra/overlay';

// Usa jquery porque los plugins de la pantalla son con jquery
// El código está traído tal cual con un poco de adaptación
/* global $ */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);
    this.#initRedondeoSlider();
    this.#conectarMostrarOcultarRedondeo();
    this.#conectarEventosForm();
  }

  #conectarEventosForm() {
    // Al guardar y devolver correcto, recargamos el cuaderno
    this.$element.on('ajax:success', () => {
      const overlay = new Overlay(this.$element);
      overlay.show();
      window.location.reload();
    });
  }

  // Mostrar el slider cuando se elige si/no
  #conectarMostrarOcultarRedondeo() {
    // TODO: quitar, el redondeo ya no se establece en el cuaderno, sino en cada fórmula
    this.$element.find('input[name=redondeo]').on('change', (e) => {
      const $input = $(e.currentTarget);
      this.$element.find('#slider').toggleClass('hidden', $input.val() === 'no');
      $('input[name="cuadernos_configuracion_form[activo_redondeo]"]').val(toInteger($(this).val() === 'si'));
    });
    this.$element.find('#cuadernos_configuracion_form_activo_redondeo').on('change', (e) => {
      const $input = $(e.currentTarget);
      this.$element.find('#slider').toggleClass('hidden', !$input.is(':checked'));
      $('input[name="cuadernos_configuracion_form[activo_redondeo]"]').val(toInteger($input.is(':checked')));
    });
  }

  #initRedondeoSlider() {
    const $input = this.$element.find('input#cuadernos_configuracion_form_redondeo');
    const valor = parseFloat($input.val() || 0.5);

    const $slider = this.$element.find('.redondeo.slider').slider({
      min: 0,
      max: 1,
      step: 0.05,
      value: valor,
      create: (event, _ui) => {
        $(event.target).find('.ui-slider-handle').append(
          `<span class="ui-slider-tooltip">${valor.toString().replace('.', ',')}</span>`,
        );
        $input.val(valor);
      },
      slide: (_event, ui) => {
        $slider.find('.ui-slider-tooltip').text(String(ui.value).replace('.', ','));
        $input.val(ui.value);
      },
    });
  }
}
